import React from 'react';

import styles from './styles.module.css';
import {Link, useStaticQuery, graphql} from 'gatsby';

const BreadCrumb = ({title, location, categories, showProducts = false}) => {
  const {allMdx} = useStaticQuery(graphql`
    query AllPages {
      allMdx {
        nodes {
          id
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }
  `);
  const {pathname} = location;
  // expolde path
  const explodePath = pathname ? pathname.split('/') : null;
  let _links = [];
  if (pathname) {
    // remove empty
    const _explodePath = explodePath.filter(e => e !== '');
    if (showProducts) _explodePath.splice(0, 1, 'products');
    // search url in all mdx
    _explodePath.forEach(e => {
      _links = [
        ..._links,
        ...allMdx.nodes.filter(a => {
          return (
            a.fields.slug.match(new RegExp(`^/${e}/$`)) !== null &&
            a.fields.slug !== pathname
          );
        }),
      ];
    });
  }
  let category = null;
  if (categories && categories.length > 0) {
    category = categories[0].node;
  }
  return (
    <span className={styles.breadcrumb}>
      <Link to="/">Accueil</Link>
      {_links.map(l => (
        <Link key="{l.id}" to={l.fields.slug}>
          {l.frontmatter.title}
        </Link>
      ))}
      {category && (
        <Link key="{category.id}" to={category.fields.slug}>
          {category.frontmatter.title}
        </Link>
      )}
      <span>{title}</span>
    </span>
  );
};

export default BreadCrumb;
